<template>
  <div class="copypage how-it-works">

    <header>
      <div class="grid-container">
        <router-link to="/"><img class="logo" src="../assets/images/global/logo.svg"></router-link>
        <router-link class="btn bg-three active" to="/register">Sign Up</router-link>
      </div>
    </header>

    <section class="background-image">
      <div class="grid-container">
        <div class="col-6">

          <h2>How it works</h2>

          <h3>PEI exChange - Exchange ideas, drive change for Africa</h3>

          <p>The first matching platform for people committed to African development</p>

          <p>The exChange is a growing online network of people truly passionate about African development.</p>
          
          <p>Get matched with people based on shared geographic, industrial focuses and specialisms. Connect, chat and exchange knowledge to make your Big Ideas for Africa a reality. Showcase your project, whatever its stage, and get recognition and exposure.</p>


          <h4>How the exChange works:</h4>

<!--           <p>Networking Reinvented

          Get matched with people that can support your Big Idea or offer the right skillsets to take your project to the next level.

          Connect and Exchange Instantly

          Easily share information and chat to exchange ideas and quickly connect with the right people and projects.

          Get Recognised

          Pin your project to the Big Ideas Map and gather feedbacks from the community, get exposure and recognition for the work you’re doing.


          How our members use the exChange

          Exchange skills and expertise  -  Gather feedbacks from the community  -  Funding opportunities
          Talent scouting          -        Project portfolio       -      Volunteering opportunities
                   Business opportunities   -        Access information from the ground     -      Collaborative research


          Ready to make big ideas for Africa happen? -->

        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// HowItWorks.vue?12bf0ed1